import { useTabularMenuContext } from "./TabularMenuContext";

export const TabPanel = () => {
  const { activeTabComponent } = useTabularMenuContext();

  return <>{activeTabComponent}</>;
};
